/* eslint-disable react/no-unstable-nested-components */
import type { CloseButtonProps } from 'react-toastify'
import { ToastContainer } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faCheck,
	faExclamationTriangle
} from '@fortawesome/pro-light-svg-icons'
import 'react-toastify/dist/ReactToastify.css'
import { faX } from '@fortawesome/pro-regular-svg-icons'

const CloseButton = (properties: CloseButtonProps) => {
	const { closeToast } = properties
	return (
		<div
			role='button'
			tabIndex={0}
			onClick={closeToast}
			onKeyDown={() => closeToast()}
			aria-label='Close'
			className='absolute right-4 top-4'
		>
			<FontAwesomeIcon icon={faX} />
		</div>
	)
}

const SuccessIcon = () => (
	<div className='flex items-center justify-center rounded-md bg-primary-100'>
		<FontAwesomeIcon icon={faCheck} className='p-1 text-primary-700' />
	</div>
)

const ErrorIcon = () => (
	<div className='flex items-center justify-center rounded-md bg-red-100'>
		<FontAwesomeIcon
			icon={faExclamationTriangle}
			className='p-1 text-red-700'
		/>
	</div>
)

const HSToast = () => (
	<ToastContainer
		closeButton={CloseButton}
		position='top-right'
		autoClose={3000}
		hideProgressBar
		theme='light'
		icon={({ type }) => {
			switch (type) {
				case 'success': {
					return <SuccessIcon />
				}
				case 'error': {
					return <ErrorIcon />
				}
				default: {
					return null
				}
			}
		}}
		className='text-sm font-normal text-gray-500'
	/>
)

export default HSToast
